import { useEffect } from "react";
import "./index.css";
import { Terminal } from "./components/Terminal";
import { resume } from "./data/resume";
import { resumeToLines } from "./data/resumeLines";
import { applyTheme } from "./themes/types";
import { amber80s } from "./themes/presets/amber80s";

export function App() {
  useEffect(() => {
    applyTheme(amber80s);
  }, []);

  return <Terminal lines={resumeToLines(resume)} />;
}

export default App;
